(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title").click(function () {
			if (!$(this).hasClass("active")) {
				$(".product-about__accordion-title.active").removeClass("active");
				$(this).addClass("active");
				$(".product-about__accordion-content").stop().slideUp(300);
				$(this)
					.siblings(".product-about__accordion-content")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".product-about__accordion-content").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
(function () {
  const SELECTOR = ".js-media-list-horizontal.swiper";

  function initMarquee(swiperEl) {
    if (!swiperEl || swiperEl.__klMarqueeOn) return;
    swiperEl.__klMarqueeOn = true;

    // Swiper wrapper
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    // Stil sınıfı
    swiperEl.classList.add("kl-marquee");

    // Swiper inline transform'larını biz yöneteceğiz
    try {
      if (swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = false;
        swiperEl.swiper.autoplay?.stop?.();
      }
    } catch (_) {}

    // Yeterince içerik yoksa klonla (sonsuzluk için şart)
    const ensureFill = () => {
      const containerW = swiperEl.clientWidth || 0;
      if (!containerW) return;

      // toplam genişlik
      let totalW = 0;
      [...wrapper.children].forEach((c) => (totalW += c.getBoundingClientRect().width));

      // en az 2x ekran genişliği kadar içerik olsun
      let guard = 0;
      while (totalW < containerW * 2 && guard < 20) {
        const clones = [...wrapper.children].map((node) => node.cloneNode(true));
        clones.forEach((c) => wrapper.appendChild(c));
        totalW = 0;
        [...wrapper.children].forEach((c) => (totalW += c.getBoundingClientRect().width));
        guard++;
      }
    };

    // Marquee animasyonu
    let x = 0;
    let last = performance.now();

    // HIZ: px/s (büyüt = hızlanır)
    const SPEED = 120; // 80-200 arası dene

    // AND ICONIC speed (30 Oct): slide widths are measured once (and again after a resize)
    // instead of on every frame, and the loop pauses while the gallery is off screen.
    // The movement looks exactly the same.
    const widths = new WeakMap();
    const widthOf = (el) => {
      let w = widths.get(el);
      if (w === undefined) {
        w = el.getBoundingClientRect().width;
        if (w > 0) widths.set(el, w);
      }
      return w;
    };
    let visible = true;
    let running = false;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        visible = entries[entries.length - 1].isIntersecting;
        if (visible && !running) {
          running = true;
          last = performance.now();
          requestAnimationFrame(tick);
        }
      }).observe(swiperEl);
    }

    function tick(now) {
      if (!visible) {
        running = false;
        return;
      }
      const dt = Math.min((now - last) / 1000, 0.1);
      last = now;

      x -= SPEED * dt;

      // İlk slide genişliği kadar kayınca başa al (sonsuz döngü)
      const first = wrapper.children[0];
      if (first) {
        const w = widthOf(first);
        if (w > 0 && Math.abs(x) >= w) {
          x += w;
          wrapper.appendChild(first); // ilk elemanı sona at
        }
      }

      wrapper.style.transform = `translate3d(${x}px,0,0)`;
      requestAnimationFrame(tick);
    }

    // İlk ölçüm + başlat
    ensureFill();
    running = true;
    requestAnimationFrame(tick);

    // Resize olursa tekrar doldur
    window.addEventListener("resize", () => {
      [...wrapper.children].forEach((c) => widths.delete(c));
      ensureFill();
    });
    // images that finish loading can change a slide's width: measure again once
    window.addEventListener("load", () => {
      [...wrapper.children].forEach((c) => widths.delete(c));
    });
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(initMarquee);
  }

  // İlk yük
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor section reload
  document.addEventListener("shopify:section:load", boot);
})();

